// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) { return "js/" + chunkId + "-legacy." + "b853f290" + ".js"; };